import { Badge } from "@/components/ui/badge";

export const CADENCE_STYLES = [
  { value: "consultative", label: "Consultative", desc: "Ask questions, offer value first" },
  { value: "direct", label: "Direct", desc: "Clear value prop, get to the point" },
  { value: "challenger", label: "Challenger", desc: "Challenge their status quo" },
  { value: "social", label: "Social Proof", desc: "Lead with referrals and proof" },
];

const STATUS_MAP = {
  enriching: { label: "Enriching...", cls: "bg-amber-500/20 text-amber-400 border-amber-500/30" },
  generating: { label: "Generating Cadence...", cls: "bg-blue-500/20 text-blue-400 border-blue-500/30" },
  ready: { label: "Ready for Review", cls: "bg-ism-teal/20 text-ism-teal border-ism-teal/30" },
  active: { label: "Active", cls: "bg-green-500/20 text-green-400 border-green-500/30" },
  completed: { label: "Completed", cls: "bg-gray-500/20 text-gray-400 border-gray-500/30" },
  error: { label: "Error", cls: "bg-red-500/20 text-red-400 border-red-500/30" },
};

export const isProcessing = (status) => status === "enriching" || status === "generating";

export const CampaignStatusBadge = ({ status }) => {
  const m = STATUS_MAP[status] || STATUS_MAP.ready;
  return <Badge className={`${m.cls} border text-xs`}>{m.label}</Badge>;
};

const PROSPECT_STATUS = {
  sequenced: "bg-ism-teal/20 text-ism-teal border-ism-teal/30",
  enriched: "bg-blue-500/20 text-blue-400 border-blue-500/30",
  skipped: "bg-gray-500/20 text-gray-400 border-gray-500/30",
};
export const prospectStatusClass = (status) => PROSPECT_STATUS[status] || "bg-amber-500/20 text-amber-400 border-amber-500/30";

const STEP_STATUS = {
  sent: "bg-green-500/20 text-green-400 border-green-500/30",
  approved: "bg-ism-teal/20 text-ism-teal border-ism-teal/30",
};
export const stepStatusClass = (status) => STEP_STATUS[status] || "bg-white/10 text-gray-400 border-white/10";

const STEP_CARD = {
  sent: "bg-green-500/5 border border-green-500/20",
  approved: "bg-ism-teal/5 border border-ism-teal/20",
};
export const stepCardClass = (status) => STEP_CARD[status] || "bg-white/5 border border-white/5";

export const StepChips = ({ cadenceConfig }) => (
  <div className="flex flex-wrap gap-1.5">
    {(cadenceConfig?.stepLabels || []).map((label, i) => {
      const day = cadenceConfig?.spacing_days?.[i] ?? "?";
      return (
        <span key={`${day}-${label}`} className="text-xs bg-white/5 text-gray-400 px-2 py-0.5 rounded-full border border-white/10">
          Day {day}: {label}
        </span>
      );
    })}
  </div>
);
